var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradingTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_53331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3688 0.151239C53.8944 1.08674 68.3114 10.5045 62.5915 20.6404C59.7484 25.6786 53.3749 28.0456 50.4673 33.0826C49.5511 34.6696 49.3563 36.7649 50.2981 38.3366C51.5328 40.3969 54.2803 40.9496 56.013 42.6129C59.0876 45.5642 57.9254 51.2924 54.5029 53.8322C47.125 59.3076 36.137 59.4024 27.2201 58.6566C17.7071 57.861 15.0844 57.6995 7.15827 63.124C4.04914 65.2519 -0.39198 63.3304 0.150895 59.2262C0.982895 52.9367 5.84089 48.1645 10.9991 44.4702C15.8151 41.0211 35.4613 35.9086 30.8259 29.5235C28.1586 25.8494 22.8994 24.8482 19.1298 22.1925C16.5919 20.4045 16.0775 18.3375 16.7314 14.9477C18.1939 7.36599 30.0901 -1.25114 44.3688 0.151239Z",
    fill: "url(#paint0_linear_1543_53331)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68534 22.1558H6.70784V17.0819C6.70784 16.7367 6.42809 16.4569 6.08284 16.4569C5.73759 16.4569 5.45784 16.7367 5.45784 17.0819V22.1558H4.48047C4.13534 22.1558 3.85547 22.4357 3.85547 22.7808V34.2332C3.85547 34.5783 4.13534 34.8582 4.48047 34.8582H5.45784V39.432C5.45784 39.7773 5.73759 40.057 6.08284 40.057C6.42809 40.057 6.70784 39.7773 6.70784 39.432V34.8582H7.68534C8.03047 34.8582 8.31034 34.5783 8.31034 34.2332V22.7808C8.31034 22.4355 8.03047 22.1558 7.68534 22.1558Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2891 22.651H20.2664V32.2249C20.2664 32.5701 20.5462 32.8499 20.8914 32.8499C21.2367 32.8499 21.5164 32.5701 21.5164 32.2249V22.651H22.4939C22.8391 22.651 23.1189 22.3711 23.1189 22.026V18.0736C23.1189 17.7285 22.8391 17.4486 22.4939 17.4486H21.5164V9.87488C21.5164 9.52963 21.2367 9.24988 20.8914 9.24988C20.5462 9.24988 20.2664 9.52963 20.2664 9.87488V17.4486H19.2891C18.9439 17.4486 18.6641 17.7285 18.6641 18.0736V22.026C18.6641 22.3713 18.9438 22.651 19.2891 22.651Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5174 44.1348H58.54V37.8109C58.54 37.4657 58.2603 37.1859 57.915 37.1859C57.5698 37.1859 57.29 37.4657 57.29 37.8109V44.1348H56.3125C55.9674 44.1348 55.6875 44.4147 55.6875 44.7598V53.7122C55.6875 54.0573 55.9674 54.3372 56.3125 54.3372H57.29V60.1609C57.29 60.5062 57.5698 60.7859 57.915 60.7859C58.2603 60.7859 58.54 60.5062 58.54 60.1609V54.3372H59.5174C59.8625 54.3372 60.1424 54.0573 60.1424 53.7122V44.7598C60.1424 44.4145 59.8625 44.1348 59.5174 44.1348Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1131 45.2971H51.1357V30.2234C51.1357 29.8781 50.856 29.5984 50.5107 29.5984C50.1655 29.5984 49.8857 29.8781 49.8857 30.2234V45.2971H48.9082C48.5631 45.2971 48.2832 45.577 48.2832 45.9221V49.8745C48.2832 50.2196 48.5631 50.4995 48.9082 50.4995H49.8857V52.5734C49.8857 52.9186 50.1655 53.1984 50.5107 53.1984C50.856 53.1984 51.1357 52.9186 51.1357 52.5734V50.4995H52.1131C52.4582 50.4995 52.7381 50.2196 52.7381 49.8745V45.9221C52.7381 45.577 52.4582 45.2971 52.1131 45.2971Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9194 18.5671C49.3744 19.0208 50.1531 18.7308 50.1981 18.0896L50.6831 11.2183C50.7156 10.7633 50.3369 10.3858 49.8819 10.4183L43.0119 10.9033C42.3706 10.9483 42.0794 11.7271 42.5344 12.1808L43.9594 13.6058L39.8295 17.7357V8.11084C39.8295 7.42046 39.2699 6.86084 38.5795 6.86084H27.5251C26.8348 6.86084 26.2751 7.42046 26.2751 8.11084V18.5821C26.2751 19.2725 26.8348 19.8321 27.5251 19.8321H27.6714V22.8353H26.694C26.3489 22.8353 26.069 23.1152 26.069 23.4603V37.4127C26.069 37.7578 26.3489 38.0377 26.694 38.0377H27.6714V40.1115C27.6714 40.4567 27.9511 40.7365 28.2964 40.7365C28.6416 40.7365 28.9214 40.4567 28.9214 40.1115V38.0377H29.8989C30.244 38.0377 30.5239 37.7578 30.5239 37.4127V33.4116L34.8604 37.7473L26.5984 46.0093C24.9795 44.6896 22.9136 43.8972 20.6621 43.8972C18.1146 43.8972 15.8054 44.912 14.1121 46.5572V42.6606H15.0896C15.4348 42.6606 15.7146 42.3807 15.7146 42.0356V33.0832C15.7146 32.7381 15.4348 32.4582 15.0896 32.4582H14.1121V24.9543C14.1121 24.6091 13.8324 24.3293 13.4871 24.3293C13.1419 24.3293 12.8621 24.6091 12.8621 24.9543V32.4582H11.8848C11.5396 32.4582 11.2598 32.7381 11.2598 33.0832V42.0356C11.2598 42.3807 11.5396 42.6606 11.8848 42.6606H12.8621V47.8043C12.8621 47.873 12.8759 47.9377 12.8963 47.9995C11.8643 49.5086 11.2598 51.3333 11.2598 53.2996C11.2598 58.4925 15.4694 62.702 20.6621 62.702C25.8549 62.702 30.0645 58.4923 30.0645 53.2996C30.0645 52.1947 29.8724 51.1351 29.5223 50.1502L40.8784 38.7832V46.7755C40.8784 47.1206 41.1583 47.4005 41.5034 47.4005H42.4809V49.4743C42.4809 49.8196 42.7606 50.0993 43.1059 50.0993C43.4511 50.0993 43.7309 49.8196 43.7309 49.4743V47.4005H44.7083C45.0534 47.4005 45.3333 47.1206 45.3333 46.7755V35.3231C45.3333 34.978 45.0534 34.6981 44.7083 34.6981H43.7309V27.1243C43.7309 26.7791 43.4511 26.4993 43.1059 26.4993C42.7606 26.4993 42.4809 26.7791 42.4809 27.1243V34.6981H41.5034C41.1583 34.6981 40.8784 34.978 40.8784 35.3231V36.6951L37.9285 33.7447V26.8917C37.9285 26.8358 37.9189 26.7828 37.9051 26.7313L47.4944 17.1421L48.9194 18.5671ZM30.5239 27.0413V23.4603C30.5239 23.1152 30.244 22.8353 29.8989 22.8353H28.9214V19.8321H37.7331L30.5239 27.0413Z",
    fill: "#3FC0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7016 55.3384H33.0527C32.7075 55.3384 32.4277 55.6181 32.4277 55.9634C32.4277 56.3086 32.7075 56.5884 33.0527 56.5884H35.7016C36.0469 56.5884 36.3266 56.3086 36.3266 55.9634C36.3266 55.6181 36.0469 55.3384 35.7016 55.3384Z",
    fill: "#3FC0FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.08203 14.082V36.932",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68534 31.8583H4.48047C4.13534 31.8583 3.85547 31.5784 3.85547 31.2333V19.7809C3.85547 19.4358 4.13534 19.1559 4.48047 19.1559H7.68534C8.03047 19.1559 8.31034 19.4358 8.31034 19.7809V31.2333C8.31034 31.5784 8.03047 31.8583 7.68534 31.8583Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68534 31.8583H4.48047C4.13534 31.8583 3.85547 31.5784 3.85547 31.2333V19.7809C3.85547 19.4358 4.13534 19.1559 4.48047 19.1559H7.68534C8.03047 19.1559 8.31034 19.4358 8.31034 19.7809V31.2333C8.31034 31.5784 8.03047 31.8583 7.68534 31.8583Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4863 21.9542V44.8042",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0896 39.6605H11.8848C11.5396 39.6605 11.2598 39.3806 11.2598 39.0355V30.0831C11.2598 29.738 11.5396 29.4581 11.8848 29.4581H15.0896C15.4348 29.4581 15.7146 29.738 15.7146 30.0831V39.0355C15.7146 39.3808 15.4348 39.6605 15.0896 39.6605Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0896 39.6605H11.8848C11.5396 39.6605 11.2598 39.3806 11.2598 39.0355V30.0831C11.2598 29.738 11.5396 29.4581 11.8848 29.4581H15.0896C15.4348 29.4581 15.7146 29.738 15.7146 30.0831V39.0355C15.7146 39.3808 15.4348 39.6605 15.0896 39.6605Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8906 6.87476V29.7249",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4939 19.651H19.2891C18.9439 19.651 18.6641 19.3711 18.6641 19.026V15.0736C18.6641 14.7285 18.9439 14.4486 19.2891 14.4486H22.4939C22.8391 14.4486 23.1189 14.7285 23.1189 15.0736V19.026C23.1189 19.3712 22.8392 19.651 22.4939 19.651Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4939 19.651H19.2891C18.9439 19.651 18.6641 19.3711 18.6641 19.026V15.0736C18.6641 14.7285 18.9439 14.4486 19.2891 14.4486H22.4939C22.8391 14.4486 23.1189 14.7285 23.1189 15.0736V19.026C23.1189 19.3712 22.8392 19.651 22.4939 19.651Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9141 34.811V57.661",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3125 51.3373H59.5174C59.8625 51.3373 60.1424 51.0574 60.1424 50.7123V41.7599C60.1424 41.4148 59.8625 41.1349 59.5174 41.1349H56.3125C55.9674 41.1349 55.6875 41.4148 55.6875 41.7599V50.7123C55.6875 51.0574 55.9674 51.3373 56.3125 51.3373Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3125 51.3373H59.5174C59.8625 51.3373 60.1424 51.0574 60.1424 50.7123V41.7599C60.1424 41.4148 59.8625 41.1349 59.5174 41.1349H56.3125C55.9674 41.1349 55.6875 41.4148 55.6875 41.7599V50.7123C55.6875 51.0574 55.9674 51.3373 56.3125 51.3373Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5098 27.2233V50.0734",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9082 47.4995H52.1131C52.4582 47.4995 52.7381 47.2196 52.7381 46.8745V42.9221C52.7381 42.577 52.4582 42.2971 52.1131 42.2971H48.9082C48.5631 42.2971 48.2832 42.577 48.2832 42.9221V46.8745C48.2832 47.2197 48.5631 47.4995 48.9082 47.4995Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9082 47.4995H52.1131C52.4582 47.4995 52.7381 47.2196 52.7381 46.8745V42.9221C52.7381 42.577 52.4582 42.2971 52.1131 42.2971H48.9082C48.5631 42.2971 48.2832 42.577 48.2832 42.9221V46.8745C48.2832 47.2197 48.5631 47.4995 48.9082 47.4995Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1055 24.1243V46.9744",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5039 44.4005H44.7088C45.0539 44.4005 45.3338 44.1206 45.3338 43.7755V32.3231C45.3338 31.978 45.0539 31.6981 44.7088 31.6981H41.5039C41.1588 31.6981 40.8789 31.978 40.8789 32.3231V43.7755C40.8789 44.1207 41.1587 44.4005 41.5039 44.4005Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5039 44.4005H44.7088C45.0539 44.4005 45.3338 44.1206 45.3338 43.7755V32.3231C45.3338 31.978 45.0539 31.6981 44.7088 31.6981H41.5039C41.1588 31.6981 40.8789 31.978 40.8789 32.3231V43.7755C40.8789 44.1207 41.1587 44.4005 41.5039 44.4005Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7012 20.6929V34.0429",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0996 31.4691H37.3045C37.6496 31.4691 37.9295 31.1892 37.9295 30.8441V23.8917C37.9295 23.5466 37.6496 23.2667 37.3045 23.2667H34.0996C33.7545 23.2667 33.4746 23.5466 33.4746 23.8917V30.8441C33.4746 31.1892 33.7545 31.4691 34.0996 31.4691Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0996 31.4691H37.3045C37.6496 31.4691 37.9295 31.1892 37.9295 30.8441V23.8917C37.9295 23.5466 37.6496 23.2667 37.3045 23.2667H34.0996C33.7545 23.2667 33.4746 23.5466 33.4746 23.8917V30.8441C33.4746 31.1892 33.7545 31.4691 34.0996 31.4691Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2969 16.832V37.6115",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6953 35.0377H29.9002C30.2453 35.0377 30.5252 34.7578 30.5252 34.4127V20.4603C30.5252 20.1152 30.2453 19.8353 29.9002 19.8353H26.6953C26.3502 19.8353 26.0703 20.1152 26.0703 20.4603V34.4127C26.0703 34.758 26.3502 35.0377 26.6953 35.0377Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6953 35.0377H29.9002C30.2453 35.0377 30.5252 34.7578 30.5252 34.4127V20.4603C30.5252 20.1152 30.2453 19.8353 29.9002 19.8353H26.6953C26.3502 19.8353 26.0703 20.1152 26.0703 20.4603V34.4127C26.0703 34.758 26.3502 35.0377 26.6953 35.0377Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.683 8.21834L50.198 15.0896C50.153 15.7308 49.3742 16.0208 48.9192 15.5671L47.4942 14.1421L34.4103 27.226L41.0378 33.8547C41.5266 34.3422 41.5266 35.1335 41.0391 35.6222L25.4403 51.236L22.7148 46.8927L34.8603 34.7472L28.2228 28.111C27.7353 27.6222 27.7353 26.831 28.2228 26.3422L43.9593 10.6058L42.5343 9.18084C42.0793 8.72708 42.3706 7.94834 43.0118 7.90334L49.8818 7.41834C50.3367 7.38584 50.7155 7.76334 50.683 8.21834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1482 44.5216L41.0391 35.6222C41.5266 35.1335 41.5266 34.3422 41.0378 33.8547L34.4103 27.226L47.4942 14.1421L48.9192 15.5671C49.3742 16.0208 50.153 15.7308 50.198 15.0896L50.683 8.21834C50.7155 7.76334 50.3367 7.38584 49.8817 7.41834L43.0117 7.90334C42.3705 7.94834 42.0792 8.72708 42.5342 9.18084L43.9592 10.6058L28.2228 26.3422C27.7353 26.831 27.7353 27.6222 28.2228 28.111L34.8603 34.7472L22.7148 46.8927",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6621 59.702C25.8549 59.702 30.0645 55.4924 30.0645 50.2996C30.0645 45.1068 25.8549 40.8972 20.6621 40.8972C15.4694 40.8972 11.2598 45.1068 11.2598 50.2996C11.2598 55.4924 15.4694 59.702 20.6621 59.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6612 57.787C24.7964 57.787 28.1486 54.4348 28.1486 50.2996C28.1486 46.1645 24.7964 42.8123 20.6612 42.8123C16.526 42.8123 13.1738 46.1645 13.1738 50.2996C13.1738 54.4348 16.526 57.787 20.6612 57.787Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6616 56.4827C24.0765 56.4827 26.8448 53.7144 26.8448 50.2996C26.8448 46.8847 24.0765 44.1165 20.6616 44.1165C17.2468 44.1165 14.4785 46.8847 14.4785 50.2996C14.4785 53.7144 17.2468 56.4827 20.6616 56.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6621 59.702C25.8549 59.702 30.0645 55.4924 30.0645 50.2996C30.0645 45.1068 25.8549 40.8972 20.6621 40.8972C15.4694 40.8972 11.2598 45.1068 11.2598 50.2996C11.2598 55.4924 15.4694 59.702 20.6621 59.702Z",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2141 48.2112H19.9595C19.4912 48.2112 19.1115 48.5908 19.1115 49.0592C19.1115 49.3943 19.3088 49.6979 19.615 49.8341L21.7105 50.7654C22.0167 50.9016 22.214 51.2052 22.214 51.5403C22.214 52.0086 21.8343 52.3883 21.366 52.3883H19.1113",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6621 48.2112V46.9573",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6621 53.6419V52.3881",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0527 53.4634H35.7016",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0527 51.2361H35.7016",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0527 49.0087H34.3771",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5798 16.832H27.5254C26.835 16.832 26.2754 16.2723 26.2754 15.582V5.11072C26.2754 4.42034 26.835 3.86072 27.5254 3.86072H38.5798C39.2701 3.86072 39.8298 4.42034 39.8298 5.11072V15.582C39.8298 16.2723 39.2701 16.832 38.5798 16.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8298 7.20509V5.11084C39.8298 4.42047 39.2701 3.86084 38.5798 3.86084H27.5254C26.835 3.86084 26.2754 4.42047 26.2754 5.11084V7.20521L39.8298 7.20509Z",
    fill: "#B4DDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2754 12.8126V15.582C26.2754 16.2723 26.835 16.832 27.5254 16.832H38.5798C39.2701 16.832 39.8298 16.2723 39.8298 15.582V5.11072C39.8298 4.42034 39.2701 3.86072 38.5798 3.86072H27.5254C26.835 3.86072 26.2754 4.42034 26.2754 5.11072V9.00609",
    stroke: "#3FC0FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9453 9.16174H29.3818",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5371 9.16174H31.9736",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1289 9.16174H34.5654",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7227 9.16174H37.1593",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9453 11.5697H29.3818",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5371 11.5697H31.9736",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9141 14.2278H37.3897L36.1786 13.114",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9283 19.1621C51.9283 19.9445 51.2941 20.5787 50.5117 20.5787C51.2941 20.5787 51.9283 21.213 51.9283 21.9954C51.9283 21.213 52.5626 20.5787 53.345 20.5787C52.5626 20.5787 51.9283 19.9445 51.9283 19.1621Z",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16272 43.4816C7.16272 44.2639 6.52847 44.8982 5.74609 44.8982C6.52847 44.8982 7.16272 45.5324 7.16272 46.3148C7.16272 45.5324 7.79697 44.8982 8.57934 44.8982C7.79697 44.8983 7.16272 44.2641 7.16272 43.4816Z",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8125 14.2334L55.6875 13.1084L54.5625 14.2334",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1953 55.3232L42.0703 54.1982L40.9453 55.3232",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9238 10.9088L12.7988 9.78381L11.6738 10.9088",
    stroke: "#B4DDF1",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_53331",
    x1: 3.55012,
    y1: 65.0659,
    x2: 60.4479,
    y2: 8.16807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DCFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5C3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_53331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingTestIcon);
export default __webpack_public_path__ + "static/media/trading-test-icon.2e06b4ca72605d12ca23dc078f0d19d4.svg";
export { ForwardRef as ReactComponent };